<template>
  <div class="scheme">
    <BaseDialog :isshow="visible" height="auto"
                title="组套导入" width="920px" @handleShow="(val)=>{
      visible = val
    }">
      <div class="schemeBox">
        <div class="scheme-left">
          <div class="leftTable">
            <div class="rigth_top">
              <el-alert :closable="false" title="组套" type="warning"/>
            </div>
            <div class="tables">
              <el-table v-loading="loading"
                        :data="tableData"
                        border
                        size="small"
                        stripe
                        width="120"
                        max-height="250px"
                        @row-click="rowclick">
                <el-table-column label="名称" prop="set_name" show-overflow-tooltip width="120"/>
              </el-table>
            </div>
            <div class="pagination-box">
              <div class="displya_flex">
                <div></div>
                <div>
                  <el-pagination :page-size="20" :total="total" background layout="prev, pager, next"
                                 small @current-change="currentings"/>
                </div>
              </div>
            </div>
          </div>
          <div class="rigthc_table">
            <!-- 顶部 -->
            <div class="rigth_top">
              <el-alert :closable="false" show-icon title="左侧选中组套所包含项目" type="warning"/>
            </div>
            <!-- 表格 -->
            <div class="tables">
              <el-table :data="rightableData"
                        border
                        max-height="250px"
                        size="small"
                        stripe
                        width="680"
                        @selection-change="handleSelectionChange">
                <el-table-column flexed="left" type="selection" width="30">
                </el-table-column>
                <el-table-column label="类别" property="drug.dict_catalog_type_name" width="60"/>
                <el-table-column label="名称" property="drug.name" show-overflow-tooltip width="120"/>
                <!-- <el-table-column label="单次剂量" property="dosage" width="80">
                </el-table-column>
                <el-table-column label="剂量单位" property="dict_dosage_unit_name" width="80">
                </el-table-column> -->
                <el-table-column width="100" label="*单次剂量">
                  <template #default="scope">
                    <el-input v-if="scope.row.drug.dict_catalog_type=='160000000'" @change="editDosage(scope.row)" v-model="scope.row.dosage">
                    </el-input>
                    <span v-else>{{scope.row.dosage}}</span>
                  </template>
                </el-table-column>
                <el-table-column width="100" label="*剂量单位">
                  <template #default="scope">
                    <el-select v-if="scope.row.drug.dict_catalog_type=='160000000'" @change="editDosageUnit(scope.row)" v-model="scope.row.dict_dosage_unit" placeholder="单位">
                      <el-option v-for="item in dictList[157000000]" :key="item.id" :label="item.name"
                                 :value="item.code"></el-option>
                    </el-select>
                    <span v-else>{{scope.row.dict_dosage_unit_name}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="用药途径" property="drug.dict_use_way_name" width="80">
                </el-table-column>
                <el-table-column label="规格" property="drug.medi_spec" show-overflow-tooltip width="120"/>
                <el-table-column label="售价" property="drug.sell_price" width="80"/>
                <el-table-column label="数量" prop="num" width="80">
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="search-top">
          <el-form ref="ruleForm1Ref" :model="ruleForm" class="demo-form-inline" label-position="right"
                   label-width="104px">
            <el-row>
              <el-col :span="10">
                <el-form-item v-if="type=='chang'" label="开始时间：">
                  <el-date-picker v-model="ruleForm.start_time" placeholder="请选择开始时间" type="datetime"
                                  value-format="YYYY-MM-DD HH:mm:ss"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item v-if="type=='chang'" label="结束时间：">
                  <el-date-picker v-model="ruleForm.end_time" placeholder="请选择结束时间" type="datetime"
                                  value-format="YYYY-MM-DD HH:mm:ss"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="备注：">
                  <el-input v-model="ruleForm.remark" :rows="2" maxlength="1000" placeholder="请输入备注" show-word-limit
                            type="textarea"/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button class="color-cancel" type="primary" @click="visible = false">
            取消
          </el-button>
          <el-button :loading="saveLoad" class="color-determine" type="primary" @click="saveLongItem">
            确定
          </el-button>
        </div>
      </template>
    </BaseDialog>
  </div>
</template>
<script>
import {reactive, toRefs, onMounted, nextTick} from 'vue'
import service from '@/utils/request'
import Rule from '@/utils/rule'
import {gitDictList, ruleTimeYear} from '@/utils/tool'
import {ElMessage} from 'element-plus'
import BaseDialog from '@/components/Dialog/index.vue'

export default {
  name: 'dialysisScheme',
  components: {
    BaseDialog,
  },
  props: ['patientId', 'recordId'],
  emits: ['refreshDataList'],
  setup(props, ctx) {
    const state = reactive({
      visible: false,
      Dialoading: false,
      currenting: 1,
      loading: false,
      saveLoad: false,
      contLoading: false,
      ruleForm1Ref: null,
      ruleForm: {},
      dictList: {},
      sid: null,
      total: 0,
      tableData: [],
      pageData: {
        currentPage: 1,
        pageSize: 10,
        totalSum: 0,
      },
      rightableData: [],
      type: '',//临时，长期
      recordId: '',
      tableSelected: []
    })

    const initData = async (item, id) => {
      getDict()
      state.type = item
      state.recordId = id
      console.log(state.recordId)
      formInit()
      state.visible = true
      tobody()
    }

    onMounted(() => {

    })
    const getDict = async () => {
      state.dictList = await gitDictList([
        '160000000',
        '157000000',
        '158000000',
        '159000000',
        '176000000',
        '332900000',
        '340200000',
      ])
    }
    // 获取左侧列表
    const tobody = async () => {
      state.loading = true
      let data = {
        type: 7,
        searche: '',
        current: state.currenting,
        size: 20,
      }
      let res = await service.post('/api/setup/getList', data)
      if (res.code === 0) {
        state.loading = false
        if (res.data.total > 0) {
          state.tableData = res.data.list
          state.total = res.data.total
          rightbody(res.data.list[0].id)
          state.sid = res.data.list[0].id
        } else {
          state.tableData = []
        }
      }
    }
    const editDosage = async (row) => {
      let data = {
        sid: state.sid,
        id: row.id,
        dosage: row.dosage,
      }
      let res = await service.post('api/setup/projectEdit', data)
      if (res.code === 0) {
        ElMessage({
          message: '修改成功',
          type: 'success',
        })
        // rightbody(state.sid)
      }
    }

    const editDosageUnit = async (row) => {
      let data = {
        sid: state.sid,
        id: row.id,
        dict_dosage_unit: row.dict_dosage_unit,
      }
      let res = await service.post('api/setup/projectEdit', data)
      if (res.code === 0) {
        ElMessage({
          message: '修改成功',
          type: 'success',
        })
        // rightbody(state.sid)
      }
    }

    // 左侧页数改变时
    const currentings = (e) => {
      console.log('页面', e)
      state.currenting = e
      tobody()
    }
    //添加颜色
    const rowStyle = (row) => {
      if (state.sid === row.row.id) {
        return {'background-color': '#ccc', cursor: 'pointer', 'color': '#333'};
      }
      return {cursor: 'pointer'};
    }
    // 左侧列表点击
    const rowclick = (row) => {
      state.sid = row.id
      rightbody(row.id)
    }
    // 右侧表格列表
    const rightbody = async (id) => {
      state.Dialoading = true
      let data = {
        sid: id,
        current: 1,
        size: 9999,
      }
      let res = await service.post('/api/setup/getPriject', data)
      if (res.code === 0) {
        if (res.data.total > 0) {
          state.rightableData = res.data.list
        } else {
          state.rightableData = []
        }
      }
      state.Dialoading = false
    }
    const formInit = () => {
      state.ruleForm = {}
      state.ruleForm = {
        start_time: ruleTimeYear(new Date()),
        end_time: ruleTimeYear(new Date()),
      }
    }
    // 复选框
    const handleSelectionChange = (e) => {
      console.log(e)
      state.tableSelected = e
      // if (e.length > 0) {
      //   e.forEach(item1 => {
      //     if (!state.tableSelected.some(item2 => item2.id == item1.id)) {
      //       state.tableSelected.push(item1)
      //     }
      //   })
      // } else {
      //   state.rightableData.forEach((item1, index1) => {
      //     let findIndex = state.tableSelected.findIndex(item2 => item2.id == item1.id)
      //     if (findIndex > -1) {
      //       state.tableSelected.splice(findIndex, 1)
      //     }
      //   })
      // }
    }
    const saveLongItem = () => {
      console.log('state.tableSelected', state.tableSelected)
      state.ruleForm1Ref.validate(async (valid) => {
        if (valid) {
          console.log(props)
          state.ruleForm.group_id = state.sid
          state.ruleForm.project_ids = state.tableSelected.map(item => {
            return item.id
          })
          state.saveLoad = true
          let res = {}
          if (state.type == 'chang') {
            state.ruleForm.record_id = ''
            state.ruleForm.patient_id = props.patientId
            res = await service.post(
                '/api/advice/createByGroup',
                state.ruleForm
            )
          } else {
            state.ruleForm.record_id = state.recordId
            state.ruleForm.patient_id = ''
            state.ruleForm.start_time = ''
            state.ruleForm.end_time = ''
            res = await service.post(
                '/api/dialysis_record/createTempAdviceByGroup',
                state.ruleForm
            )
          }
          
          if (res.code === 0) {
            state.saveLoad = false
            state.tableSelected = []
            ElMessage.success(res.msg)
            if (!state.continuous) {
              state.visible = false
            }
            ctx.emit('refreshDataList')
          }else{
            state.saveLoad = false
          }
        }
      })
    }

    return {
      ...toRefs(state),
      initData,
      tobody,
      saveLongItem,
      rightbody,
      rowclick,
      rowStyle,
      formInit,
      handleSelectionChange,
      currentings,
      getDict,
      editDosage,
      editDosageUnit
    }
  },
}
</script>

<style lang="scss" scoped>
.el-input {
  width: 214px;
  // margin-right: 62px;
}

.schemeBox {
  margin-top: 10px;
}

.scheme-left {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.demo-Form {
  margin-top: 0;

  .el-form-item {
    width: 100%;
  }

  &:deep(.el-form-item__content) {
    // width: calc(100% - 260px);
    font-size: 14px;
    font-family: 'Source Han Sans CN-Regular';
    color: #444444;
  }

  &:deep(.el-form-item .el-input) {
    width: 120px;
    margin-right: 2px;
  }
}

.scheme-tag {
  background: rgba(49, 102, 174, 0.1);
  border-radius: 8px;
  padding: 4px 20px;
  padding-bottom: 0;
  margin: 16px 0;

  .name {
    font-size: 14px;
    color: #3166ae;
  }

  .el-tag {
    margin-bottom: 4px;
  }
}

.scheme-cont {
  padding: 0 10px;
  margin-top: 20px;
  border-right: 1px solid #e0e0e0;
  height: 310px;
  padding-left: 0;

  .item {
    height: 32px;
    line-height: 32px;
    width: 100%;
    font-size: 14px;
    font-family: 'Source Han Sans CN-Medium';
    color: #444444;
    padding-right: 14px;
    margin-bottom: 12px;

    .lable {
      background-color: #ffffff;
      border-radius: 4px;
      padding-left: 20px;
      cursor: pointer;
    }

    &.active {
      border-right: 4px solid #3166ae;

      .lable {
        background-color: rgba(49, 102, 174, 0.3);
        color: #3166ae;
      }
    }

    &:hover {
      .lable {
        background-color: rgba(49, 102, 174, 0.3);
        color: #3166ae;
      }
    }
  }
}

.scheme-right {
  width: 444px;

  .fa {
    color: #3166ae;
    margin-left: 12px;
  }

  .fixedDate {
    .el-radio {
      margin-right: 126px;

      &:last-child {
        margin-right: 0;
      }
    }

    .el-alert {
      margin: 10px 0 20px;
      color: #ff3e3e;
    }

    .el-checkbox {
      margin-right: 126px;
      margin-bottom: 8px;

      &:nth-child(3n + 3) {
        margin-right: 0px;
      }
    }
  }

  .el-form-item {
    margin-bottom: 18px;
    margin-right: 0;

    .fa {
      font-size: 22px;
    }

    &.icon {
      &:deep(.el-input) {
        width: 232px;
        margin-right: 0;
      }
    }
  }

  &:deep(.el-radio-group.height-40 .el-radio-button__inner) {
    padding: 12px 26px;
  }

  &:deep(.el-input),
  &:deep(.el-form .el-form-item__content .el-date-editor.el-input) {
    width: 264px;
  }

  &:deep(.el-input-group__append .el-input) {
    width: 80px;
  }

  &:deep(.el-textarea) {
    width: 338px;
  }
}

.dialog-footer {
  text-align: right;
  margin-top: 10px;

  .color-cancel {
    background: #ffffff;
    color: #3166ae;
  }
}
</style>
